import { useSearchParams } from "react-router-dom";
import { Catalog } from "@/components/Catalog";
import { AdUnit } from "@/components/AdUnit";

export default function Browse() {
  const [params] = useSearchParams();
  return (
    <main data-testid="browse-page" className="pt-32 pb-10 min-h-screen">
      <Catalog initialQuery={params.get("q") || ""} title="Browse" />
      <AdUnit testId="ad-unit-browse" className="mt-20" />
    </main>
  );
}
